/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-08-13 10:35:31
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-10-27 21:47:30
 */
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState({
			baseInfo: state => {
				return state.vuex_baseInfo;
			},
		}),
	},
	data() {
		return {
			defaultAvatar: 'https://cdn.chaoyongbushou.com/wx/20211108/1636372139805-c010edeb4a822302594d57f1bb6687c.png',
		};
	},
	methods: {
		/**
		 * 打开新tab
		 * @url 需要打开的链接
		 * 使用a标签的target=_blank属性
		 */
		openBlankWindow(url) {
			var a = document.createElement('a');
			a.setAttribute('href', url);
			a.setAttribute('target', '_blank');
			a.setAttribute('id', 'jump');
			if (!document.getElementById('jump')) {
				document.body.appendChild(a);
			}
			a.click();
			setTimeout(function() {
				document.body.removeChild(a);
			}, 300);
		},
	},
};
